// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .video-selection {
  position: absolute;
  top: 35px;
  bottom: 0px;
  overflow: auto;
  width: calc(100% - 10px);
}
:host .section-item {
  width: 100%;
}
:host .section-item-block input, :host span {
  width: calc(100% - 15px);
}
:host .item-device-tag {
  width: calc(100% - 5px);
}
:host .item-slider {
  margin-left: 20px;
  width: 100px;
}
:host .toolbox {
  float: right;
  margin-bottom: 3px;
}
:host .toolbox button {
  margin-right: 8px;
  margin-left: 8px;
}
:host .action-readonly-item {
  display: block;
  /* min-height: 100px; */
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 5px 0px 5px 0px;
}
:host .action-readonly-item .tag {
  width: calc(100% - 5px);
}
:host .action-readonly-item .tag input {
  width: inherit;
}
:host .action-readonly-item .value {
  width: calc(100% - 5px);
}
:host .action-readonly-item .value .number > input {
  width: 50px;
}
:host .action-readonly-item .value .type > input {
  width: auto;
}
:host .static-image mat-select, :host .static-image span {
  width: calc(100% - 15px);
}
:host .static-image img {
  max-width: 200px;
  max-height: 160px;
}
:host .static-image button {
  float: right;
}
:host ::ng-deep .mat-tab-label {
  height: 34px !important;
  min-width: 110px !important;
  width: 110px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/gauges/controls/html-video/video-property/video-property.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/gauges/controls/html-video/video-property/video-property.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;ACAR;ADGI;EACI,WAAA;ACDR;ADII;EACI,wBAAA;ACFR;ADKI;EACI,uBAAA;ACHR;ADMI;EACI,iBAAA;EACA,YAAA;ACJR;ADOI;EACI,YAAA;EAEA,kBAAA;ACNR;ADSI;EACI,iBAAA;EACA,gBAAA;ACPR;ADUI;EACI,cAAA;EACA,uBAAA;EACA,WAAA;EACA,2CAAA;EACA,wBAAA;ACRR;ADWQ;EACI,uBAAA;ACTZ;ADUY;EACI,cAAA;ACRhB;ADWQ;EACI,uBAAA;ACTZ;ADWY;EACI,WAAA;ACThB;ADWY;EACI,WAAA;ACThB;ADeQ;EACI,wBAAA;ACbZ;ADgBQ;EACI,gBAAA;EACA,iBAAA;ACdZ;ADgBQ;EACI,YAAA;ACdZ;ADkBI;EACI,uBAAA;EACA,2BAAA;EACA,uBAAA;AChBR","sourcesContent":[":host {\n    .video-selection {\n        position: absolute;\n        top: 35px;\n        bottom: 0px;\n        overflow: auto;\n        width:calc(100% - 10px);\n    }\n\n    .section-item {\n        width: 100%;\n    }\n\n    .section-item-block input, span {\n        width:calc(100% - 15px);\n    }\n\n    .item-device-tag {\n        width:calc(100% - 5px);\n    }\n\n    .item-slider {\n        margin-left: 20px;\n        width: 100px;\n    }\n\n    .toolbox {\n        float: right;\n        // margin-top: 5px;\n        margin-bottom: 3px;\n    }\n\n    .toolbox button {\n        margin-right: 8px;\n        margin-left: 8px;\n    }\n\n    .action-readonly-item {\n        display: block;\n        /* min-height: 100px; */\n        width: 100%;\n        border-bottom: 1px solid rgba(0,0,0,0.1);\n        padding: 5px 0px 5px 0px;\n\n\n        .tag {\n            width: calc(100% - 5px);\n            input {\n                width: inherit;\n            }\n        }\n        .value {\n            width: calc(100% - 5px);\n\n            .number > input {\n                width: 50px;\n            }\n            .type > input {\n                width: auto;\n            }\n        }\n    }\n\n    .static-image {\n        mat-select, span {\n            width: calc(100% - 15px);\n        }\n\n        img {\n            max-width: 200px;\n            max-height: 160px;\n        }\n        button {\n            float: right;\n        }\n    }\n\n    ::ng-deep .mat-tab-label {\n        height: 34px !important;\n        min-width: 110px !important;\n        width: 110px !important;\n    }\n}",":host .video-selection {\n  position: absolute;\n  top: 35px;\n  bottom: 0px;\n  overflow: auto;\n  width: calc(100% - 10px);\n}\n:host .section-item {\n  width: 100%;\n}\n:host .section-item-block input, :host span {\n  width: calc(100% - 15px);\n}\n:host .item-device-tag {\n  width: calc(100% - 5px);\n}\n:host .item-slider {\n  margin-left: 20px;\n  width: 100px;\n}\n:host .toolbox {\n  float: right;\n  margin-bottom: 3px;\n}\n:host .toolbox button {\n  margin-right: 8px;\n  margin-left: 8px;\n}\n:host .action-readonly-item {\n  display: block;\n  /* min-height: 100px; */\n  width: 100%;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 5px 0px 5px 0px;\n}\n:host .action-readonly-item .tag {\n  width: calc(100% - 5px);\n}\n:host .action-readonly-item .tag input {\n  width: inherit;\n}\n:host .action-readonly-item .value {\n  width: calc(100% - 5px);\n}\n:host .action-readonly-item .value .number > input {\n  width: 50px;\n}\n:host .action-readonly-item .value .type > input {\n  width: auto;\n}\n:host .static-image mat-select, :host .static-image span {\n  width: calc(100% - 15px);\n}\n:host .static-image img {\n  max-width: 200px;\n  max-height: 160px;\n}\n:host .static-image button {\n  float: right;\n}\n:host ::ng-deep .mat-tab-label {\n  height: 34px !important;\n  min-width: 110px !important;\n  width: 110px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
